<h3>Seção de Marcas</h3>
<form class="form-b4a" [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="brands-section">
    <span class="p-float-label w-full">
      <p-autoComplete
        [suggestions]="brands"
        formControlName="selectedBrand"
        filterBy="name"
        optionLabel="name"
        appendTo="body"
        [lazy]="false"
        [multiple]="false"
        (completeMethod)="searchBrands($event)"
        placeholder="Busque pelo nome da marca"
        name="selectedBrand"
        inputId="selectedBrand"
        (onSelect)="addBrand($event)"
      />
      <label for="selectedBrand">Adicionar Marca</label>
    </span>

    <div
      formArrayName="brands"
      cdkDropList
      (cdkDropListDropped)="onDrop($event)"
      class="brands-grid"
    >
      <div
        *ngFor="let brand of brandsFormArray.controls; let i = index"
        [formGroupName]="i"
        class="brand-item p-card"
        cdkDrag
      >
        <div class="brand-content">
          <img
            [src]="brandsFormArray.at(i).get('image')?.value"
            alt="Preview da marca"
            class="brand-preview"
            *ngIf="brandsFormArray.at(i).get('image')?.value"
          />
        </div>
        <div class="brand-actions">
          <p-button
            type="button"
            icon="pi pi-arrows-alt"
            class="p-button-text p-button-rounded p-mr-2"
            pTooltip="Arrastar para reordenar"
            cdkDragHandle
          />
          <p-button
            type="button"
            icon="pi pi-trash"
            severity="danger"
            (click)="removeBrand(i)"
            class="p-button-sm remove-button"
          />
        </div>
      </div>
    </div>
  </div>

  <span class="buttons">
    <p-button
      label="Voltar"
      severity="danger"
      routerLink="/configuracoes/mens/home"
    />
    <p-button label="Salvar" type="submit" [disabled]="!form.valid" />
  </span>
</form>
